<template>
    <div class="product-detail">
      <!-- 标题栏 -->
      <div class="header">
        <button class="back-button" @click="goBack">
          <img src="@/assets/arrow-left-s-line.png" alt="返回" class="back-icon" />
        </button>
        <h1>{{ product.productName }}</h1>
      </div>
  
      <!-- 内容区域（可滚动） -->
    <div class="content">
      <!-- 产品主体信息 -->
        <!-- 
      <div class="product-main">
        <img :src="product.mainPic" :alt="product.productName" class="main-image" />
        <div class="product-info">
          <p class="product-desc">{{ product.productDesc }}</p>
          <div class="product-meta">
            <p class="product-price">价格: ¥{{ product.productPrice }}</p>
            <p class="product-stock">库存: {{ product.quantityLeft }}</p>
          </div>
        </div>
      </div>-->

      <!-- 产品详情图列表 -->
      <div class="detail-images">
        <img
          v-for="(image, index) in detailImages"
          :key="index"
          :src="image"
          :alt="'产品详情图 ' + (index + 1)"
          class="detail-image"
        />
      </div>
    </div>
  
      <!-- 底部立即兑换按钮 -->
      <div class="footer">
        <button class="exchange-button" @click="handleExchange">立即兑换</button>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { Options, Vue } from 'vue-class-component';
  
  @Options({})
  export default class ProductDetailView extends Vue {
    product: Product = {
      cardTypeId: '',
      detailPicFive: '',
      detailPicFour: '',
      detailPicOne: '',
      detailPicSix: '',
      detailPicThree: '',
      detailPicTwo: '',
      isValid: true,
      mainPic: '',
      productDesc: '',
      productId: '',
      productName: '',
      productPrice: 0,
      quantityLeft: 0,
      quantityTotal: 0,
    };
  
    // 产品详情图列表
    get detailImages(): string[] {
      return [
        this.product.detailPicOne,
        this.product.detailPicTwo,
        this.product.detailPicThree,
        this.product.detailPicFour,
        this.product.detailPicFive,
        this.product.detailPicSix,
      ].filter((img) => img); // 过滤掉空字符串
    }
  
    created() {
      // 从路由 query 中获取传递的 product 对象
      const productStr = this.$route.query.product as string;
      if (productStr) {
        this.product = JSON.parse(productStr);
      }
    }
  
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    }
  
    // 处理立即兑换逻辑
    handleExchange() {
    this.$router.push({
        path: '/exchange',
        query: {
        cardTypeId: this.product.cardTypeId, // 传递 cardTypeId
        productId: this.product.productId, // 传递 productId
        productName: this.product.productName, // 传递 productName
        },
    });
    }
  }
  
  // 定义产品数据结构
  interface Product {
    cardTypeId: string;
    detailPicFive: string;
    detailPicFour: string;
    detailPicOne: string;
    detailPicSix: string;
    detailPicThree: string;
    detailPicTwo: string;
    isValid: boolean;
    mainPic: string;
    productDesc: string;
    productId: string;
    productName: string;
    productPrice: number;
    quantityLeft: number;
    quantityTotal: number;
  }
  </script>
  
  <style scoped>
.product-detail {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #f5f5f5;
}

.header {
  display: flex;
  align-items: center;
  padding: 16px;
  background: linear-gradient(to bottom, #ff3b3b, #ff7e7e); /* 红色渐变色 */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: relative;
  text-align: center;
}

.back-button {
  background: none;
  border: none;
  font-size: 24px;
  color: white; /* 返回按钮颜色改为白色 */
  cursor: pointer;
  position: absolute;
  left: 16px;
}

.back-icon {
  width: 24px;
  height: 24px;
}

.header h1 {
  font-size: 18px;
  color: white; /* 标题颜色改为白色 */
  margin: 0 auto;
}

/* 内容区域（可滚动） */
.content {
  flex: 1;
  overflow-y: auto; /* 允许滚动 */
  padding-bottom: 80px; /* 留出底部按钮的空间 */
}

.product-main {
  padding: 16px;
  background-color: #ffffff;
  margin-bottom: 16px;
}

.main-image {
  width: 100%;
  height: auto;
  border-radius: 8px;
  margin-bottom: 16px;
}

.product-info {
  text-align: left;
}

.product-desc {
  font-size: 14px;
  color: #666;
  margin-bottom: 12px;
}

.product-meta {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #333;
}

.detail-images {
  padding: 16px;
  background-color: #ffffff;
}

.detail-image {
  width: 100%;
  height: auto;
  border-radius: 8px;
  margin-bottom: 16px;
}

/* 底部按钮 */
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  background-color: #ffffff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.exchange-button {
  width: 100%;
  padding: 12px;
  background-color: #ff7e7e;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
}

.exchange-button:hover {
  background-color: #ff5a5a;
}
</style>